import { Component } from '@angular/core';
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';

@Component({
  selector: 'app-page-error-reload',
  templateUrl: './page-error-reload.component.html',
  styleUrls: ['./page-error-reload.component.scss']
})
export class PageErrorReloadComponent {

  constructor(public mls: MultiLangService) { }


  reload_page(): void {
    // tslint:disable-next-line: deprecation
     window.location.reload();
  }
}
